'use client';

import { useEffect } from 'react';

import ErrorPage from '@/views/errorPage';

const Generic_Error_Title = 'Something went wrong';
const Generic_Error_Message =
  'An error has occurred. If the issue persists, please contact our support team.';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    window.reportError(error);
  }, [error]);

  return (
    <ErrorPage
      errorCode={0}
      errorMessage={Generic_Error_Message}
      title={Generic_Error_Title}
    />
  );
}
